export enum ModalType {
  /* Payment */
  PaymentPending = 'PaymentPending',
  PaymentFailed = 'PaymentFailed',
  PaymentCompleted = 'PaymentCompleted',

  /* Order */
  CancelOrder = 'CancelOrder ',

  /* Payout account */
  CreatePayoutAccount = 'CreatePayoutAccount',
  ActivatePayoutAccount = 'ActivatePayoutAccount',

  /* Auth */
  AuthenticationPending = 'AuthenticationPending',
  AuthenticationFailed = 'AuthenticationFailed',

  /* Member */
  AddMembers = 'AddMembers',

  /* Sale */
  Sell = 'Sell',
  CreateSale = 'CreateSale',
}
